/**
 * Slate Mobile Navigation Menu
 *
 */
"use strict";

var menu_toggle = document.getElementById('main-menu-toggle');
var main_menus = document.querySelectorAll('.main-menu');
var sub_menus = document.querySelectorAll(".main-menu > ul[role='menu']");

// Functions for handling menu state
function toggle_main_menu_open() {
	menu_toggle.classList.toggle( "open" );
	for (var i = 0; main_menus.length > i; i++ ) { main_menus[i].classList.toggle("open"); }
	for (var i = 0; sub_menus.length > i; i++ ) { sub_menus[i].classList.toggle("open"); }
}

function close_main_menu() {
	menu_toggle.classList.remove( "open" );
	for (var i = 0; main_menus.length > i; i++ ) { main_menus[i].classList.remove("open"); }
	for (var i = 0; sub_menus.length > i; i++ ) { sub_menus[i].classList.remove("open"); }
}

// Alter Menu state
if (menu_toggle) {
	menu_toggle.addEventListener( "click", function() {
		toggle_main_menu_open();
	});
	
	window.addEventListener( 'keyup', function(e){
		if ( e.keyCode == 27) { // escape key maps to keycode `27`
			close_main_menu();
		}
	});
	
	// Add a class to the menu button when the user clicks it so that it has a
	// different appearance/style when clicked (indicating it has been activated)
	// and thus, the menu expanded.
	var parent_buttons = document.querySelectorAll( ".main-menu__item--parent button" );
	
	for (var i = 0; parent_buttons.length > i; i++ ) {
		parent_buttons[i].addEventListener( 'click', function() {
			this.classList.toggle('rotated_expand-button');
			this.nextElementSibling.classList.toggle("expanded_main-menu__submenu");
		});
	}
}